import styled from "styled-components";
import { breakpoints } from "theme/breakpoints";

interface ContainerProps {
  isOnScreen?: boolean;
}

export const Container = styled.footer<ContainerProps>`
  position: relative;
  width: 100%;
  opacity: ${({ isOnScreen }) => (isOnScreen ? 1 : 0)};
  transition: opacity 1s 1s;
`;

export const Column = styled.div`
  line-height: 1.8rem;

  @media (max-width: ${breakpoints.md}) {
    :first-child {
      margin-top: 0;
    }

    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 50px;
    align-self: center;
    text-align: center;
  }

  &&.company-address {
    line-height: 1.5rem;
  }
`;
